import { render, staticRenderFns } from "./Dates.vue?vue&type=template&id=72f7349a&"
import script from "./Dates.vue?vue&type=script&lang=ts&"
export * from "./Dates.vue?vue&type=script&lang=ts&"
import style0 from "./Dates.vue?vue&type=style&index=0&id=72f7349a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports